import React, { useState, useEffect } from "react";
import { FileUploader } from "react-drag-drop-files";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Table,
  Badge
} from "reactstrap";
import classnames from "classnames";
import * as moment from "moment";
import { api } from "../../config";

import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { fetchComAuth, fetchComAuthJson } from "../../common/api";
import { LucideChartNoAxesColumnIncreasing } from "lucide-react";

const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

const EtapasProcesso = ({
  etapas,
  reservaId,
  feiraId,
  cancelada,
  venda,
  onUpdate,
  formaPagamentoId,
  condicaoPagamentoId,
  valor,
  comerciais,
  comercialId,
  renovou,
  parcelas = [],
  observacaoFinanceiraAtual = '',
  ehRenovacao
}) => {
  
  const [modalCancelar, setModalCancelar] = useState(false);
  const [modalFinalizarVenda, setModalFinalizarVenda] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalProrrogar, setModalProrrogar] = useState(false);
  const [modalComercial, setModalComercial] = useState(false);
  const [etapasDisponiveis, setEtapasDisponiveis] = useState([]);
  const [etapaSelecionada, setEtapaSelecionada] = useState("");
  const [observacao, setObservacao] = useState("");
  const [diasProrrogar, setDiasProrrogar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const authUser = JSON.parse(sessionStorage.getItem("authUser")) || {};
  const userData = authUser.user || authUser;
  const userType = userData.tipo || '';
  const [modalEditarFinanceiro, setModalEditarFinanceiro] = useState(false);
  const [valorTotal, setValorTotal] = useState(valor);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [condicoesPagamento, setCondicoesPagamento] = useState([]);
  const [formaPagamentoSelecionada, setFormaPagamentoSelecionada] = useState('');
  const [condicaoPagamentoSelecionada, setCondicaoPagamentoSelecionada] = useState('');
  const [observacaoFinanceira, setObservacaoFinanceira] = useState('');
  const [loadingFinanceiro, setLoadingFinanceiro] = useState(false);
  const [modalArquivos, setModalArquivos] = useState(false);
  const [files, setFiles] = useState([]);
  const [observacaoArquivos, setObservacaoArquivos] = useState("");
  const [loadingArquivos, setLoadingArquivos] = useState(false);
  const [arquivosEnviados, setArquivosEnviados] = useState([]);
  const [emailRenovacao, setEmailRenovacao] = useState("");
  //const [comerciaisFeira, setComerciaisFeira] = useState([]);
  const [comercialSelecionado, setComercialSelecionado] = useState('');

  const [gerarParcelas, setGerarParcelas] = useState(false);
  const [quantidadeParcelas, setQuantidadeParcelas] = useState(1);
  const [primeiraDataVencimento, setPrimeiraDataVencimento] = useState('');
  const [periodicidadeParcelas, setPeriodicidadeParcelas] = useState('mensal');
  const [intervaloDias, setIntervaloDias] = useState(30);
  const [parcelasPreview, setParcelasPreview] = useState([]);

  
  const gerarPreviewParcelas = ({
    valorTotal,
    quantidadeParcelas,
    primeiraDataVencimento,
    periodicidadeParcelas,
    intervaloDias,
  }) => {
    const valor = Number(valorTotal || 0);
    const qtd = Number(quantidadeParcelas || 1);

    if (!valor || !qtd || !primeiraDataVencimento) {
      return [];
    }

    const valorTotalCentavos = Math.round(valor * 100);
    const valorBaseCentavos = Math.floor(valorTotalCentavos / qtd);
    const restoCentavos = valorTotalCentavos - valorBaseCentavos * qtd;

    const primeiraData = moment(primeiraDataVencimento);

    return Array.from({ length: qtd }).map((_, index) => {
      let vencimento;

      if (periodicidadeParcelas === 'mensal') {
        vencimento = primeiraData.clone().add(index, 'months');
      } else if (periodicidadeParcelas === 'quinzenal') {
        vencimento = primeiraData.clone().add(index * 15, 'days');
      } else if (periodicidadeParcelas === 'semanal') {
        vencimento = primeiraData.clone().add(index, 'weeks');
      } else {
        vencimento = primeiraData.clone().add(index * Number(intervaloDias || 30), 'days');
      }

      const numeroParcela = index + 1;

      const valorCentavos =
        numeroParcela === qtd
          ? valorBaseCentavos + restoCentavos
          : valorBaseCentavos;

      return {
        numero_parcela: numeroParcela,
        total_parcelas: qtd,
        data_vencimento: vencimento.format('YYYY-MM-DD'),
        valor: valorCentavos / 100,
      };
    });
  };


  const normalizarTextoCondicao = (texto) => {
    return String(texto || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const obterQuantidadeParcelasPeloTexto = (textoCondicao) => {
    const texto = normalizarTextoCondicao(textoCondicao);

    if (!texto) return 1;

    if (
      texto.includes("a vista") ||
      texto.includes("avista") ||
      texto.includes("pagamento unico") ||
      texto.includes("unico")
    ) {
      return 1;
    }

    // Ex.: 30/60/90 ou 30 / 60 / 90 / 120
    if (/^\d+(\s*\/\s*\d+)+$/.test(texto)) {
      return texto.split("/").filter((item) => item.trim() !== "").length;
    }

    // Ex.: entrada + 3x
    const matchEntradaMaisX = texto.match(/entrada\s*\+\s*(\d+)\s*x/);
    if (matchEntradaMaisX) {
      return Number(matchEntradaMaisX[1]) + 1;
    }

    // Ex.: 3x, 6x, 10x
    const matchVezes = texto.match(/(\d+)\s*x/);
    if (matchVezes) {
      return Number(matchVezes[1]);
    }

    // Ex.: 3 parcelas, 4 parcela
    const matchParcelas = texto.match(/(\d+)\s*parcela/);
    if (matchParcelas) {
      return Number(matchParcelas[1]);
    }

    return 1;
  };

  const obterCondicaoPagamentoPorId = (condicoes = [], condicaoId) => {
    return condicoes.find((condicao) => String(condicao.id) === String(condicaoId));
  };

  const atualizarParcelasPelaCondicao = ({
    condicaoId,
    condicoes = condicoesPagamento,
    valorBase = valorTotal,
    dataBase = primeiraDataVencimento,
    periodicidade = periodicidadeParcelas,
    intervalo = intervaloDias,
  }) => {
    const condicao = obterCondicaoPagamentoPorId(condicoes, condicaoId);
    const qtdParcelas = obterQuantidadeParcelasPeloTexto(condicao?.nome);
    const dataInicial = dataBase || moment().add(7, "days").format("YYYY-MM-DD");

    setQuantidadeParcelas(qtdParcelas);

    const preview = gerarPreviewParcelas({
      valorTotal: Number(valorBase || 0),
      quantidadeParcelas: qtdParcelas,
      primeiraDataVencimento: dataInicial,
      periodicidadeParcelas: periodicidade,
      intervaloDias: intervalo,
    });

    setParcelasPreview(preview);

    return {
      qtdParcelas,
      dataInicial,
      preview,
    };
  };

  const normalizarParcelasSalvas = (parcelasSalvas = []) => {
  return [...parcelasSalvas]
    .sort((a, b) => Number(a.numero_parcela || 0) - Number(b.numero_parcela || 0))
    .map((parcela, index, array) => ({
      id: parcela.id || null,
      numero_parcela: parcela.numero_parcela || index + 1,
      total_parcelas: parcela.total_parcelas || array.length,
      data_vencimento: parcela.data_vencimento
        ? moment(parcela.data_vencimento).format('YYYY-MM-DD')
        : '',
      valor: Number(parcela.valor || 0),
      status: parcela.status || 'prevista',
    }));
};

const calcularTotalParcelas = (parcelas = []) => {
  return parcelas.reduce((total, parcela) => {
    return total + Number(parcela.valor || 0);
  }, 0);
};

const handleAlterarParcela = (index, campo, valorCampo) => {
  setParcelasPreview((parcelasAtuais) => {
    return parcelasAtuais.map((parcela, parcelaIndex) => {
      if (parcelaIndex !== index) return parcela;

      return {
        ...parcela,
        [campo]: campo === 'valor' ? Number(valorCampo || 0) : valorCampo,
      };
    });
  });
};

const distribuirCentavosEntreParcelas = (valorTotalCentavos, quantidade) => {
  if (!quantidade || quantidade <= 0) return [];

  const valorBaseCentavos = Math.floor(valorTotalCentavos / quantidade);
  const restoCentavos = valorTotalCentavos - valorBaseCentavos * quantidade;

  return Array.from({ length: quantidade }).map((_, index) => {
    return index === quantidade - 1
      ? valorBaseCentavos + restoCentavos
      : valorBaseCentavos;
  });
};

const recalcularDemaisParcelas = (indexParcelaFixa) => {
  setParcelasPreview((parcelasAtuais) => {
    if (!parcelasAtuais || parcelasAtuais.length <= 1) {
      toast.info('É necessário ter mais de uma parcela para recalcular.');
      return parcelasAtuais;
    }

    const totalFinanceiroCentavos = Math.round(Number(valorTotal || 0) * 100);
    const valorParcelaFixaCentavos = Math.round(
      Number(parcelasAtuais[indexParcelaFixa]?.valor || 0) * 100
    );

    if (valorParcelaFixaCentavos > totalFinanceiroCentavos) {
      toast.error('O valor desta parcela não pode ser maior que o valor total.');
      return parcelasAtuais;
    }

    const indicesParaRecalcular = parcelasAtuais
      .map((_, index) => index)
      .filter((index) => index !== indexParcelaFixa);

    const valorRestanteCentavos = totalFinanceiroCentavos - valorParcelaFixaCentavos;
    const valoresDistribuidos = distribuirCentavosEntreParcelas(
      valorRestanteCentavos,
      indicesParaRecalcular.length
    );

    const novasParcelas = parcelasAtuais.map((parcela, index) => {
      if (index === indexParcelaFixa) {
        return parcela;
      }

      const posicaoDistribuicao = indicesParaRecalcular.indexOf(index);

      return {
        ...parcela,
        valor: Number((valoresDistribuidos[posicaoDistribuicao] / 100).toFixed(2)),
      };
    });

    toast.success('Demais parcelas recalculadas com sucesso.');

    return novasParcelas;
  });
};

const recalcularParcelasPeloValorTotal = () => {
  const preview = gerarPreviewParcelas({
    valorTotal,
    quantidadeParcelas,
    primeiraDataVencimento,
    periodicidadeParcelas,
    intervaloDias,
  });

  setParcelasPreview(preview);
};

  const etapasOrdenadas = [...etapas].sort((a, b) => 
    new Date(a.created_at) - new Date(b.created_at)
  );

  const buscarDadosPagamento = async () => {
    try {
      // Busca formas de pagamento
      const responseFormas = await fetchComAuth(`${api.API_URL}/forma-pagamento`, {
        method: 'GET'
      });
      const dataFormas = await responseFormas.json();
      const formas = dataFormas.data || [];
      setFormasPagamento(formas);

      // Busca condições de pagamento
      const responseCondicoes = await fetchComAuth(`${api.API_URL}/condicao-pagamento`, {
        method: 'GET'
      });
      const dataCondicoes = await responseCondicoes.json();
      const condicoes = dataCondicoes.data || [];
      setCondicoesPagamento(condicoes);

      return {
        formas,
        condicoes,
      };
    } catch (error) {
      console.error("Erro ao buscar dados de pagamento:", error);
      toast.error("Erro ao carregar formas de pagamento");
      return {
        formas: [],
        condicoes: [],
      };
    }
  };
    // const userFeirasIds = userData.feiras?.map(item => item.feira_id) || [];

  // Função para formatar a data
  const formatarData = (date) => {
    return moment(new Date(date)).format("DD/MM/YYYY [às] HH:mm");
  };

  const handleEtapaChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setEtapaSelecionada(selectedId);
    if (selectedId !== 7) {
      setEmailRenovacao(""); // limpa caso mude para outro
    }
  };

  const handleEnviarArquivos = async () => {
    try {
      setLoadingArquivos(true);
      
      const formData = new FormData();
      const filesArray = files instanceof FileList ? 
      Array.from(files) : 
      (Array.isArray(files) ? files : []);

    // Adiciona cada arquivo ao FormData
    filesArray.forEach(file => {
      formData.append('arquivos', file); // Sem os colchetes []
    });
  
      formData.append('reserva_id', reservaId);
      formData.append('observacao', observacaoArquivos);
      formData.append('feira_id', feiraId);

      const response = await fetchComAuthJson(`${api.API_URL}/reserva/arquivos/${reservaId}`, {
        method: 'POST',
        body: formData
      });


      if (response.status) {
        toast.success("Arquivos enviados com sucesso!");
        setModalArquivos(false);
        setFiles([]);
        setObservacaoArquivos("");
        if (onUpdate) onUpdate();
      } else {
        throw new Error(response.data.message || "Falha ao enviar arquivos");
      }
    } catch (err) {
      toast.error(err.message || "Erro ao enviar arquivos");
    } finally {
      setLoadingArquivos(false);
    }
  };

  const salvarEdicaoFinanceira = async () => {
    setLoadingFinanceiro(true);
    try {
      if (!formaPagamentoSelecionada) {
        toast.error("Selecione a forma de pagamento.");
        setLoadingFinanceiro(false);
        return;
      }

      if (!condicaoPagamentoSelecionada) {
        toast.error("Selecione a condição de pagamento.");
        setLoadingFinanceiro(false);
        return;
      }

      if (Number(valorTotal) < 0) {
        toast.error("Informe um valor total válido.");
        setLoadingFinanceiro(false);
        return;
      }

      if (gerarParcelas) {
        if (!quantidadeParcelas || Number(quantidadeParcelas) <= 0) {
          toast.error("Informe a quantidade de parcelas.");
          setLoadingFinanceiro(false);
          return;
        }

        if (!primeiraDataVencimento) {
          toast.error("Informe a primeira data de vencimento.");
          setLoadingFinanceiro(false);
          return;
        }
      }

      if (gerarParcelas) {
        const parcelasInvalidas = parcelasPreview.some((parcela) => {
          return !parcela.data_vencimento || Number(parcela.valor || 0) <= 0;
        });

        if (parcelasInvalidas) {
          toast.error("Todas as parcelas precisam ter data de vencimento e valor maior que zero.");
          setLoadingFinanceiro(false);
          return;
        }

        const totalParcelas = Number(calcularTotalParcelas(parcelasPreview).toFixed(2));
        const totalFinanceiro = Number(Number(valorTotal || 0).toFixed(2));

        if (totalParcelas !== totalFinanceiro) {
          toast.error("A soma das parcelas precisa ser igual ao valor total financeiro.");
          setLoadingFinanceiro(false);
          return;
        }
      }

      const response = await fetchComAuthJson(`${api.API_URL}/reserva/financeiro`, {
        method: 'POST',
        body: JSON.stringify({
          reserva_id: reservaId,
          feira_id: feiraId,
          forma_pagamento_id: formaPagamentoSelecionada,
          condicao_pagamento_id: condicaoPagamentoSelecionada,
          valor_total: Number(valorTotal || 0),
          gerar_parcelas: gerarParcelas,

          quantidade_parcelas: gerarParcelas ? parcelasPreview.length : 0,
          primeira_data_vencimento: gerarParcelas ? parcelasPreview[0]?.data_vencimento : null,
          periodicidade_parcelas: periodicidadeParcelas,
          intervalo_dias: intervaloDias,

          parcelas: gerarParcelas
            ? parcelasPreview.map((parcela, index) => ({
                id: parcela.id || null,
                numero_parcela: index + 1,
                total_parcelas: parcelasPreview.length,
                data_vencimento: parcela.data_vencimento,
                valor: Number(parcela.valor || 0),
                status: parcela.status || 'prevista',
              }))
            : [],

          observacao: observacaoFinanceira,
        })
      });

      if (response.ok) {
        setSuccess('Dados financeiros atualizados com sucesso!');
        setModalEditarFinanceiro(false);
        setObservacao('');
        setFormaPagamentoSelecionada(null);
        setCondicaoPagamentoSelecionada(null);
        setValorTotal(0);
        setLoadingFinanceiro(false);
        if (onUpdate) onUpdate();
      } else {
        toast.error("Erro ao atualizar dados financeiros!");
         setLoadingFinanceiro(false);
      }
    } catch (err) {
      console.log(err);
       setLoadingFinanceiro(false);
      toast.error("Falha na conexão com o servidor");
    }
  };

  const getEtapaIcon = (etapaReserva) => {
    switch (etapaReserva?.nome?.toLowerCase()) {
      case "solicitação recebida":
        return "ri-shopping-bag-line";
      case "em análise":
        return "ri-file-search-line";
      case "aprovada":
        return "ri-checkbox-circle-line";
      case "em preparação":
        return "ri-truck-line";
      case "em transporte":
        return "ri-truck-line";
      case "entregue":
        return "ri-home-4-line";
      case "concluído":
        return "ri-check-double-line";
      default:
        return "ri-information-line";
    }
  };

  const getEtapaColor = (etapaReserva) => {
    switch (etapaReserva?.nome?.toLowerCase()) {
      case "solicitação recebida":
        return "primary";
      case "em análise":
        return "info";
      case "aprovada":
        return "success";
      case "em preparação":
        return "warning";
      case "em transporte":
        return "warning";
      case "entregue":
        return "danger";
      case "concluído":
        return "success";
      default:
        return "secondary";
    }
  };

  const abrirModalEditarFinanceiro = async () => {
    setLoadingFinanceiro(true);

    try {
      const dadosPagamento = await buscarDadosPagamento();
      const condicoesCarregadas = dadosPagamento?.condicoes || [];

      const parcelasSalvas = normalizarParcelasSalvas(parcelas);
      const possuiParcelasSalvas = parcelasSalvas.length > 0;

      const condicaoIdAtual = condicaoPagamentoId || '';
      const valorAtual = Number(valor || 0);
      const dataInicial = moment().add(7, 'days').format('YYYY-MM-DD');

      setFormaPagamentoSelecionada(formaPagamentoId || '');
      setCondicaoPagamentoSelecionada(condicaoIdAtual);
      setValorTotal(valorAtual);

      if (possuiParcelasSalvas) {
        setGerarParcelas(true);
        setParcelasPreview(parcelasSalvas);
        setQuantidadeParcelas(parcelasSalvas.length);
        setPrimeiraDataVencimento(parcelasSalvas[0]?.data_vencimento || '');
        setPeriodicidadeParcelas('mensal');
        setIntervaloDias(30);
      } else {
        
        if (valor > 0) {
          const condicaoAtual = obterCondicaoPagamentoPorId(condicoesCarregadas, condicaoIdAtual);
          const qtdParcelas = obterQuantidadeParcelasPeloTexto(condicaoAtual?.nome);

          setGerarParcelas(true);
          setQuantidadeParcelas(qtdParcelas);
          setPrimeiraDataVencimento(dataInicial);
          setPeriodicidadeParcelas('mensal');
          setIntervaloDias(30);

          const previewInicial = gerarPreviewParcelas({
            valorTotal: valorAtual,
            quantidadeParcelas: qtdParcelas,
            primeiraDataVencimento: dataInicial,
            periodicidadeParcelas: 'mensal',
            intervaloDias: 30,
          });

          setParcelasPreview(previewInicial);
        }
      }

      setObservacaoFinanceira(observacaoFinanceiraAtual || '');

      setModalEditarFinanceiro(true);
    } catch (error) {
      toast.error("Erro ao preparar edição financeira");
    } finally {
      setLoadingFinanceiro(false);
    }
  };

  const abrirModalAlterarComercial = async () => {
    setLoading(true);
    try {
      setComercialSelecionado(comercialId);
      setModalComercial(true);
    } catch (error) {
      toast.error("Erro ao preparar edição financeira");
    } finally {
      setLoading(false);
    }
  }; 
  
  const abrirModalEditar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuth(`${api.API_URL}/etapa-reserva`, {
        method: 'GET'
      });
      
      const data = await response.json();
      
      // 1. Filtra os IDs 7, 8 e 9
      let etapasFiltradas = (data.data || []).filter(etapa => ![7, 8, 9].includes(etapa.id));
      
      if (!ehRenovacao) {
        etapasFiltradas = etapasFiltradas.filter(etapa => ![10, 11].includes(etapa.id));
      }
      // 2. Alimenta o estado com a lista filtrada (e não a original)
      setEtapasDisponiveis(etapasFiltradas);
      
      setModalEditar(true);
      
    } catch (err) {
      setError(err.message || 'Falha ao carregar etapas disponíveis');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/cancelar`, {
        method: 'POST',
        body: JSON.stringify({
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSuccess('Reserva cancelada com sucesso!');
        setModalCancelar(false);
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao cancelar reserva');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar cancelamento');
    } finally {
      setLoading(false);
    }
  };

  const handleFinalizarVenda = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/finalizar`, {
        method: 'POST',
        body: JSON.stringify({
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSuccess('Reserva atualizada com sucesso!');
        setModalFinalizarVenda(false);
        setObservacao('');
        if (onUpdate) onUpdate(); 
      } else {
        throw new Error(data.message || 'Falha ao cancelar reserva');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar cancelamento');
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/etapa`, {
        method: 'POST',
        body: JSON.stringify({
          etapa_reserva_id: etapaSelecionada,
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId,
          email_renovacao: etapaSelecionada === 7 ? emailRenovacao : null
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSuccess('Etapa atualizada com sucesso!');
        setModalEditar(false);
        setEtapaSelecionada('');
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao atualizar etapa');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar atualização');
    } finally {
      setLoading(false);
    }
  };

  const handleProrrogar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/prorrogar`, {
        method: 'POST',
        body: JSON.stringify({
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId,
          dias:diasProrrogar
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success("Prorrogação solicitada com sucesso!");
        setModalProrrogar(false);
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao solicitar prorrogação');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar prorrogação');
    } finally {
      setLoading(false);
    }
  };

  const handleAlterarComercial = async () => {
    try {
      setLoading(true);
      setError(null);
       
      const response = await fetchComAuthJson(`${api.API_URL}/comercialReserva`, {
        method: 'PUT',
        body: JSON.stringify({
          comercial_id: comercialSelecionado,
          reserva_id: reservaId,
          usuario_id: userData.id,
          feira_id: feiraId
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success('Comercial alterado com sucesso!');
        setModalComercial(false);
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao solicitar alteração');
      }
      
    } catch (err) {
      setError(err.message || 'Falha ao solicitar alteração');
    } finally {
      setLoading(false);
    }
  };

  return (
    
    <>
      <Card>
        <ToastContainer closeButton={false} />
        <CardHeader>
            <div className="d-flex flex-wrap gap-2">
            { ((cancelada && ['COMERCIAL'].includes(userType))) ? <div></div> : 
              <>
                <Button onClick={() => setModalArquivos(true)} color='primary' className="shadow-none btn-soft-primary btn-sm mt-2 mt-sm-0"> <i className="ri-attachment-line align-middle me-1"></i> Enviar Arquivos </Button>
                <Button onClick={() => abrirModalEditarFinanceiro(true)} className="shadow-none btn-soft-secondary btn-sm mt-2 mt-sm-0"> <i className="ri-edit-2-line me-1"></i> Editar Dados Financeiros </Button>
              </>
            }

          {venda ? <div></div> : 
            <>
              <Button onClick={abrirModalEditar} className="shadow-none btn-soft-success btn-sm mt-2 mt-sm-0"> <i className="ri-map-pin-line align-middle me-1"></i>{" "}Atualizar Reserva </Button>
              <Button onClick={() => setModalProrrogar(true)} className="shadow-none btn-soft-info btn-sm mt-2 mt-sm-0"> <i className="ri-time-line align-middle me-1"></i>{" "} Prorrogar Reserva </Button>
              <Button onClick={() => setModalCancelar(true)} className="shadow-none btn-soft-danger btn-sm mt-2 mt-sm-0"> <i className="mdi mdi-archive-remove-outline align-middle me-1"></i>{" "} Cancelar Reserva </Button>
            </>
          }

            {(['JOTAPIX', 'EVOMAP', 'ORGANIZACAO'].includes(userType)) && (
              <>
                <Button onClick={() => abrirModalAlterarComercial(true)} className="shadow-none btn-soft-warning btn-sm mt-2 mt-sm-0"> <i className="ri-shopping-bag-line align-middle me-1"></i>{" "}Alterar Comercial </Button>
              </>
            )}


            {!venda && !renovou && (
              <Button
                onClick={() => setModalFinalizarVenda(true)}
                color="success"
                className="mt-2 mt-sm-0"
              >
                <i
                  className="ri-money-dollar-box-fill me-2"
                  style={{ fontSize: "large" }}
                ></i>
                Finalizar Venda
              </Button>
            )}
            
          </div>
        </CardHeader>
        <CardBody>
        
          {error && <Alert color="danger">{error}</Alert>}
          {success && <Alert color="success">{success}</Alert>}
          
        <div className="d-sm-flex align-items-center">
            <h5 className="card-title flex-grow-1 mb-0">Acompanhe o processo :</h5>
           
          </div>
          <div className="profile-timeline">
            <div className="accordion accordion-flush" id="accordionFlushExample">
              {etapasOrdenadas?.map((etapa, index) => {
                const isLast = index === etapasOrdenadas.length - 1;
                const icon = getEtapaIcon(etapa.etapa_reserva);
                const color = getEtapaColor(etapa.etapa_reserva);
                
                return (
                  <div className="accordion-item border-0" key={`etapa-${etapa.id}`}>
                    <div className="accordion-header" id={`heading-${etapa.id}`}>
                      <button
                        type="button"
                        className={classnames(
                          "accordion-button",
                          "p-2",
                          "shadow-none",
                          { collapsed: !isLast }
                        )}
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${etapa.id}`}
                        aria-expanded={isLast ? "true" : "false"}
                        aria-controls={`collapse-${etapa.id}`}
                      >
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 avatar-xs">
                            <div className={`avatar-title bg-${color} rounded-circle`}>
                              <i className={icon}></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="fs-15 mb-0 fw-semibold">
                              {etapa.etapa_reserva?.nome || "Etapa do Processo"} -{" "}
                              <span className="fw-normal">
                                {formatarData(etapa.created_at)}
                              </span>
                            </h6>
                            <h6 className="mb-1">
                              Obs: {etapa.observacao || "Sem observações adicionais"}
                            </h6>
                            <p className="text-muted mb-0">
                              {etapa.usuario && (
                                <span> Atualizado por {etapa.usuario.name || "usuário não identificado"}</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div
                      id={`collapse-${etapa.id}`}
                      className={classnames(
                        "accordion-collapse",
                        "collapse",
                        { show: isLast }
                      )}
                      aria-labelledby={`heading-${etapa.id}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                      {/* <div className="accordion-body ms-2 ps-5 pt-0">
                        <h6 className="mb-1">
                          {etapa.observacao || "Sem observações adicionais"}
                        </h6>
                        <p className="text-muted mb-0">
                          Atualizado em: {formatarData(etapa.updated_at)}
                          {etapa.usuario && (
                            <span> por {etapa.usuario.name || "usuário não identificado"}</span>
                          )}
                        </p>
                      </div> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </CardBody>
      </Card>

      <Modal isOpen={modalArquivos} toggle={() => setModalArquivos(!modalArquivos)} size="lg">
        <ModalHeader toggle={() => setModalArquivos(!modalArquivos)}>
          <i className="ri-file-upload-line me-2"></i>
          Enviar Arquivos
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Arquivos</Label>
              <FileUploader
              label="Arraste e solte arquivos aqui ou clique para selecionar"
            hoverTitle="Solte aqui!"
                multiple={true}
                handleChange={(files) => setFiles(files)}
                name="arquivos"
                types={["JPG", "PNG", "PDF", "DOC", "DOCX", "XLS", "XLSX"]}
              >
                
                </FileUploader>
              <div className="mt-2">
                {files.length > 0 && (
                  <div>
                    <h6>Arquivos selecionados:</h6>
                    <ul>
                      {Array.from(files).map((file, index) => (
                        <li key={index}>{file.name}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </FormGroup>
            
            <FormGroup>
              <Label>Observação</Label>
              <Input
                type="textarea"
                value={observacaoArquivos}
                onChange={(e) => setObservacaoArquivos(e.target.value)}
                placeholder="Informe uma observação sobre os arquivos (opcional)"
                rows="3"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalArquivos(false)} disabled={loadingArquivos}>
            Cancelar
          </Button>
          <Button 
            color="primary" 
            onClick={handleEnviarArquivos} 
            disabled={loadingArquivos || files.length === 0}
          >
            {loadingArquivos ? 'Enviando...' : 'Enviar Arquivos'}
          </Button>
        </ModalFooter>
      </Modal>

        
      <Modal isOpen={modalEditarFinanceiro} toggle={() => setModalEditarFinanceiro(false)} size="lg">
      <ModalHeader toggle={() => setModalEditarFinanceiro(false)}>
        <i className="ri-money-dollar-circle-line me-2"></i>
        Editar Dados Financeiros
      </ModalHeader>
      <ModalBody>
        {loadingFinanceiro ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Forma de Pagamento</Label>
                  <Input
                    type="select"
                    value={formaPagamentoSelecionada}
                    onChange={(e) => setFormaPagamentoSelecionada(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    {formasPagamento.map((forma) => (
                      <option key={forma.id} value={forma.id}>
                        {forma.nome}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Condição de Pagamento</Label>
                  <Input
                    type="select"
                    value={condicaoPagamentoSelecionada}
                    onChange={(e) => {
                      const condicaoId = e.target.value;
                      setCondicaoPagamentoSelecionada(condicaoId);

                      if (gerarParcelas) {
                        atualizarParcelasPelaCondicao({
                          condicaoId,
                          condicoes: condicoesPagamento,
                          valorBase: valorTotal,
                          dataBase: primeiraDataVencimento || moment().add(7, 'days').format('YYYY-MM-DD'),
                          periodicidade: periodicidadeParcelas,
                          intervalo: intervaloDias,
                        });

                        if (!primeiraDataVencimento) {
                          setPrimeiraDataVencimento(moment().add(7, 'days').format('YYYY-MM-DD'));
                        }
                      }
                    }}
                  >
                    <option value="">Selecione...</option>
                    {condicoesPagamento.map((condicao) => (
                      <option key={condicao.id} value={condicao.id}>
                        {condicao.nome}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Valor Total (R$)</Label>
                  <Input
                    type="number"
                    value={valorTotal}
                    onChange={(e) => {
                      const novoValor = e.target.value;
                      setValorTotal(novoValor);
                    }}
                    min="0"
                    step="0.01"
                  />
                </FormGroup>
              </Col>
              
              <Col md={6}>
                <FormGroup check className="mt-4">
                  <Input
                    type="checkbox"
                    checked={gerarParcelas}
                    onChange={(e) => setGerarParcelas(e.target.checked)}
                  />
                  <Label check>
                    Gerar previsão de parcelas
                  </Label>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              
              {gerarParcelas && (
                <>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Periodicidade</Label>
                      <Input
                        type="select"
                        value={periodicidadeParcelas}
                        onChange={(e) => {
                          const novaPeriodicidade = e.target.value;
                          setPeriodicidadeParcelas(novaPeriodicidade);

                          const preview = gerarPreviewParcelas({
                            valorTotal,
                            quantidadeParcelas,
                            primeiraDataVencimento,
                            periodicidadeParcelas: novaPeriodicidade,
                            intervaloDias,
                          });

                          setParcelasPreview(preview);
                        }}
                      >
                        <option value="mensal">Mensal</option>
                        <option value="quinzenal">Quinzenal</option>
                        <option value="semanal">Semanal</option>
                        <option value="dias">Personalizada em dias</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Quantidade de Parcelas</Label>
                      <Input
                        type="number"
                        min="1"
                        value={quantidadeParcelas}
                        onChange={(e) => {
                          const novaQuantidade = e.target.value;
                          setQuantidadeParcelas(novaQuantidade);

                          const preview = gerarPreviewParcelas({
                            valorTotal,
                            quantidadeParcelas: novaQuantidade,
                            primeiraDataVencimento,
                            periodicidadeParcelas,
                            intervaloDias,
                          });

                          setParcelasPreview(preview);
                        }}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup>
                      <Label>Primeiro Vencimento</Label>
                      <Input
                        type="date"
                        value={primeiraDataVencimento}
                        onChange={(e) => {
                          const novaData = e.target.value;
                          setPrimeiraDataVencimento(novaData);

                          const preview = gerarPreviewParcelas({
                            valorTotal,
                            quantidadeParcelas,
                            primeiraDataVencimento: novaData,
                            periodicidadeParcelas,
                            intervaloDias,
                          });

                          setParcelasPreview(preview);
                        }}
                      />
                    </FormGroup>
                  </Col>

<Col md={12}>
  <Button
    color="secondary"
    outline
    size="sm"
    type="button"
    onClick={recalcularParcelasPeloValorTotal}
  >
    <i className="ri-refresh-line me-1"></i>
    Recalcular parcelas pelo valor total
  </Button>
</Col>
                </>
              )}
            </Row>

            {gerarParcelas && (
              <Row>
                {periodicidadeParcelas === 'dias' && (
                  <Col md={6}>
                    <FormGroup>
                      <Label>Intervalo em dias</Label>
                      <Input
                        type="number"
                        min="1"
                        value={intervaloDias}
                        onChange={(e) => {
                          const novoIntervalo = e.target.value;
                          setIntervaloDias(novoIntervalo);

                          const preview = gerarPreviewParcelas({
                            valorTotal,
                            quantidadeParcelas,
                            primeiraDataVencimento,
                            periodicidadeParcelas,
                            intervaloDias: novoIntervalo,
                          });

                          setParcelasPreview(preview);
                        }}
                      />
                    </FormGroup>
                  </Col>
                )}
              </Row>
            )}

    {Number(calcularTotalParcelas(parcelasPreview).toFixed(2)) !== Number(valorTotal || 0) && (
      <Alert color="warning" className="mt-2 mb-0">
        A soma das parcelas está diferente do valor total informado.
      </Alert>
    )}
    
{gerarParcelas && parcelasPreview.length > 0 && (
  <div className="table-responsive mt-3">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h6 className="mb-0">Previsão das Parcelas</h6>

      <small className="text-muted">
        Total das parcelas: <strong>{formatCurrency(calcularTotalParcelas(parcelasPreview))}</strong>
      </small>
    </div>

    <Table bordered size="sm">
      <thead className="table-light">
        <tr>
          <th style={{ width: '120px' }}>Parcela</th>
          <th>Vencimento</th>
          <th className="text-end">Valor</th>
          <th style={{ width: '150px' }}>Ações</th>
        </tr>
      </thead>

      <tbody>
        {parcelasPreview.map((parcela, index) => (
          <tr key={parcela.id || parcela.numero_parcela}>
            <td>
              {parcela.numero_parcela}/{parcelasPreview.length}
            </td>

            <td>
              <Input
                type="date"
                value={parcela.data_vencimento || ''}
                onChange={(e) =>
                  handleAlterarParcela(index, 'data_vencimento', e.target.value)
                }
              />
            </td>

            <td>
              <Input
                type="number"
                min="0"
                step="0.01"
                className="text-end"
                value={parcela.valor}
                onChange={(e) =>
                  handleAlterarParcela(index, 'valor', e.target.value)
                }
              />
            </td>

            <td>
              <Button
                color="primary"
                outline
                size="sm"
                type="button"
                disabled={parcelasPreview.length <= 1}
                onClick={() => recalcularDemaisParcelas(index)}
              >
                Ajustar demais
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>

   
  </div>
)}
            <FormGroup>
              <Label>Observação</Label>
              <Input
                type="textarea"
                value={observacaoFinanceira}
                onChange={(e) => setObservacaoFinanceira(e.target.value)}
                rows="2"
              />
            </FormGroup>
          </Form>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setModalEditarFinanceiro(false)}>
          Cancelar
        </Button>
        <Button color="primary" onClick={salvarEdicaoFinanceira} disabled={loadingFinanceiro}>
          {loadingFinanceiro ? 'Salvando...' : 'Salvar Alterações'}
        </Button>
      </ModalFooter>
      </Modal>

      <Modal isOpen={modalCancelar} toggle={() => setModalCancelar(!modalCancelar)} centered={true}>
        <ModalHeader toggle={() => setModalCancelar(!modalCancelar)}>Cancelar Reserva</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="observacaoCancelar">Motivo do Cancelamento</Label>
              <Input
                type="textarea"
                id="observacaoCancelar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe o motivo do cancelamento"
                required
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalCancelar(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="danger" onClick={handleCancelar} disabled={loading}>
            {loading ? 'Processando...' : 'Confirmar Cancelamento'}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalFinalizarVenda} toggle={() => setModalFinalizarVenda(!modalFinalizarVenda)} centered={true}>
        <ModalHeader toggle={() => setModalFinalizarVenda(!modalFinalizarVenda)}>Deseja realmente Finalizar Venda? </ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="observacaoFinalizar">Observação</Label>
              <Input
                type="textarea"
                id="observacaoFinalizar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe a observação"
                required
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalFinalizarVenda(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="success" onClick={handleFinalizarVenda} disabled={loading}>
            {loading ? 'Processando...' : 'Confirmar Venda'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Editar Reserva */}
      <Modal isOpen={modalEditar} toggle={() => setModalEditar(!modalEditar)}>
        <ModalHeader toggle={() => setModalEditar(!modalEditar)}>Alterar Etapa da Reserva</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="etapaReserva">Nova Etapa</Label>
              <Input
                type="select"
                id="etapaReserva"
                value={etapaSelecionada}
                onChange={handleEtapaChange}
                disabled={loading || etapasDisponiveis.length === 0}
              >
                <option value="">Selecione uma etapa</option>
                {etapasDisponiveis.map((etapa) => (
                  <option key={etapa.id} value={etapa.id}>
                    {etapa.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="observacaoEditar">Observação</Label>
              <Input
                type="textarea"
                id="observacaoEditar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe uma observação (opcional)"
              />
            </FormGroup>
            {etapaSelecionada === 7 && (
              <FormGroup>
                <Label for="emailRenovacao">E-mail de Renovação</Label>
                <Input
                  type="email"
                  id="emailRenovacao"
                  value={emailRenovacao}
                  onChange={(e) => setEmailRenovacao(e.target.value)}
                  placeholder="Digite o e-mail para renovação"
                  required
                />
              </FormGroup>
            )}

          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalEditar(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="primary" onClick={handleEditar} disabled={loading || !etapaSelecionada}>
            {loading ? 'Processando...' : 'Salvar Alteração'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Prorrogar Reserva */}
      <Modal isOpen={modalProrrogar} toggle={() => setModalProrrogar(!modalProrrogar)}>
        <ModalHeader toggle={() => setModalProrrogar(!modalProrrogar)}>Solicitar Prorrogação</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="observacaoProrrogar">Motivo da Prorrogação</Label>
              <Input
                type="textarea"
                id="observacaoProrrogar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe o motivo da prorrogação"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="diasProrrogar">Dias de Prorrogação</Label>
              <Input
                type="textarea"
                id="diasProrrogar"
                value={diasProrrogar}
                onChange={(e) => setDiasProrrogar(e.target.value)}
                placeholder="Informe a quantidade de dias para prorrogação"
                required
              />
            </FormGroup>
            <p className="text-muted">
              O prazo de prorrogação padrão será aplicado automaticamente caso nao seja informada a quantidade de dias.
            </p>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalProrrogar(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="warning" onClick={handleProrrogar} disabled={loading}>
            {loading ? 'Processando...' : 'Solicitar Prorrogação'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Alterar Comercial Reserva */}
      <Modal isOpen={modalComercial} toggle={() => setModalComercial(!modalComercial)}>
        <ModalHeader toggle={() => setModalComercial(!modalComercial)}>Solicitar Alteração Comercial</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="comercial">Comercial</Label>
              <Input
                type="select"
                value={comercialSelecionado}
                onChange={(e) => setComercialSelecionado(e.target.value)}
              >
        
                <option value="">Selecione...</option>
                {comerciais.map((com) => (
                  <option key={com.id} value={com.id}>
                    {com.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalComercial(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="warning" onClick={handleAlterarComercial} disabled={loading}>
            {loading ? 'Processando...' : 'Solicitar Alteração'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EtapasProcesso;